// extracted by mini-css-extract-plugin
module.exports = {"likeButtonGroupMessage":"like-button-group-message_likeButtonGroupMessage__ta0E_"};